import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			units: [],
			imagesForModal: []
		};
	},
	beforeMount: function () {
		var results = this.$el.getElementsByClassName('unit-list-section');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}
		var facilityId;
		let el = document.querySelector("[data-facility]");
		if (el) {
			facilityId = parseInt(el.getAttribute('data-facility'), 10);
		} else {
			//console.log('element beds is not found..................');
		}
		if (facilityId) {
			var unitGroup = this.getUnitGroupId(facilityId);
			var req = {
				fields: this.resultFields,
				filter: {
					unitgroupid: unitGroup
				},
				sorting: 'random',
				max: 6
			};

			doReq('searchUnits', req)
				.then((res) => {
					this.units = res.units;
				});
		}

	},

	mounted: function () {
		this.$nextTick(function () {
			window.addEventListener('resize', this.handleResize);
		});
	},

	updated: function () {

		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();


	},
	beforeDestroy: function () {
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		getUnitGroupId: function (facilityId) {
			var unitgroup;
			if (facilityId == 232411) {
				unitgroup = 72723;
			} else if (facilityId == 232345) {
				unitgroup = 72658;
			} else if (facilityId == 224002) {
				unitgroup = 72093;
			} else if (facilityId == 232347) {
				unitgroup = 72659;
			} else if (facilityId == 232347) {
				unitgroup = 72661;
			} else if (facilityId == 232409) {
				unitgroup = 72724;
			} else if (facilityId == 232350) {
				unitgroup = 72662;
			} else if (facilityId == 232412) {
				unitgroup = 72725;
			} else if (facilityId == 232414) {
				unitgroup = 72726;
			} else if (facilityId == 232416) {
				unitgroup = 72727;
			} else if (facilityId == 232410) {
				unitgroup = 72728;
			} else if (facilityId == 232415) {
				unitgroup = 72729;
			} else if (facilityId == 232413) {
				unitgroup = 72730;
			} else if (facilityId == 232349) {
				unitgroup = 72663;
			} else if (facilityId == 232346) {
				unitgroup = 72660;
			}
			return unitgroup;
		},

		getSearchPath: function (facilityId) {
			return 's#?unitgroupid=' + this.getUnitGroupId(facilityId);
		},

		handleResize: function () {
			this.applySlider();

		},
		handleEscKey: function (event) {
			if (event.key === 'Escape' || event.key === 'Esc') {
				const modals = document.querySelectorAll('.modal-custom');
				modals.forEach(modal => {
					if (modal.style.display === 'block') {
						modal.style.display = 'none';
						document.body.classList.remove('modal-open');
					}
				});

				window.removeEventListener('keydown', this.handleEscKey);

			}
		},
		showImagesModal: function (images, uniqueId = '') {
			if (images && images.length > 1) {
				this.imagesForModal = images;
				//$('#unitImages').modal('show');
				this.showCustomModal('unitImages' + uniqueId);

			} else {
				this.imagesForModal = [];
			}
		},
		showCustomModal: function (id) {

			let wh = window.innerHeight;

			// Get the modal
			const modal = document.getElementById(id);

			if (modal) {
				var dialog = modal.getElementsByClassName("modal-custom-dialog")[0];
				var content = modal.getElementsByClassName("modal-custom-content")[0];
				var body = document.body;

				if (dialog && content) {
					dialog.style.height = wh - 40 + "px";
					content.style.height = wh - 120 + "px";

					modal.style.display = "block";
					body.classList.add('modal-open');

					// ESC-Taste aktivieren
					window.addEventListener('keydown', this.handleEscKey);

					// When the user clicks anywhere outside of the modal, close it
					window.onclick = function (event) {
						if (event.target == modal) {
							modal.style.display = "none";
							body.classList.remove('modal-open');
						}
					};
				}
			}

		},

		closeCustomModal: function (id) {
			const modal = document.getElementById(id);
			var body = document.body;
			if (modal) {
				modal.style.display = "none";
				body.classList.remove('modal-open');
			}

		},
		getUnitSearchTarget: function (id) {
			return 'unit_' + id;
		},

	}
};